import React, { useContext, useState, useEffect } from 'react';
import { UserContext } from '../Contexts/UserContext';
import { Link, useParams, useSearchParams } from 'react-router-dom';
import { aoiService } from "../Services/aoiService";
import { eventService } from "../Services/eventService";
import Moment from "react-moment";
import EditEvent from "../Components/UserProfile/Events/EditEvent";
import CreateEvent from "../Components/UserProfile/Events/CreateEvent";
import EventDelete from "../Components/UserProfile/EventDelete";
import AoiEvents from "../Components/Events/AoiEvents";


const ManageEvents = (props) => {
    let { aoiId, eventId } = useParams();
    const { user, setUser, showAlert, selectedOrgId } = useContext(UserContext);
    const [aois, setAois] = useState([]);
    const [aoi, setAoi] = useState(null);
    const [aoiParts, setAoiParts] = useState([]);
    const [allEvents, setAllEvents] = useState([]);
    const [editEvent, setEditEvent] = useState(null);
    const [showDelete, setShowDelete] = useState(false);
    const [selectedAoi, setSelectedAoi] = useState(null);
    const [selectedPart, setSelectedPart] = useState(null);

    useEffect(() => {
        reloadData();
    }, []);

    const reloadData = () => {
        aoiService.getAoisByOrgId(selectedOrgId).then((data) => {
            console.log(data);
            setAois(data);
            if(aoiId != null) {
                const sAoi = data.find(a => a.aoiId == aoiId);
                if(sAoi != null)
                    setAoi(sAoi);
            }
        });
    };

    useEffect(() => {
        if(aoiId != null) {
            const sAoi = aois.find(a => a.aoiId == aoiId);
            if(sAoi != null)
                setAoi(sAoi);
        }
    }, [aoiId, aois]);

    const renderAoiPart = (aoi, part) => {
        console.log(part);
        return <div className="profile-row aoipart event-pipeline-name" key={part.aoiPartGuid}>
            {aoi.name} - {part.name}
            <a className="add-btn-link" onClick={() => startCreating(aoi, part)}>Create Event</a>
        </div>;
    };

    const renderAoiParts = (aoi) => {
        const parts = aoiParts.filter((p) => p.aoiGuid = aoi.aoiGuid);
        return parts.map((part) => renderAoiPart(aoi, part));
    };

    const startCreating = (aoi, part) => {
        setSelectedAoi(aoi);
        setSelectedPart(part);

        let event = {
            isInternal: true,
            imageCredits: "",
            images: []
        };
        part.aoiPartsInfo.map((part) => {
            event.images.push({
                imageId: part.aoiPartInfoId,
                maxx: part.maxx,
                maxy: part.maxy,
                minx: part.minx,
                miny: part.miny,
                name: part.name,
                imagePath: ""
            });
        });
        setEditEvent(event);
    };

    const startEditing = (event) => {
        setEditEvent(event);
    };

    const startDeleting = (event) => {
        setShowDelete(true);
        setEditEvent(event);
    }

    const renderAoiEvents = (aoi) => {
        const events = allEvents.filter((e) => e.aoiGuid == aoi.aoiGuid);
        return <div>
            <h5><b>Events for {aoi.name}</b></h5>
            <div className="event-list-container">
                {
                    events.map((e) => {
                        return <div className="event-list-row">
                            <Moment date={e.eventDate} format={"DD-MMMM-YYYY"}></Moment>
                            <a className="add-btn-link" onClick={() => startEditing(e)}>Edit Event</a>
                            <a className="add-btn-link" onClick={() => startDeleting(e)}>Delete Event</a>
                        </div>;
                    })
                }
            </div>
        </div>;
    };

    const cancelEdit = () => {
        setEditEvent(null);
        setSelectedAoi(null);
        setSelectedPart(null);
    };

    const onSave = () => {
        reloadData();
        cancelEdit();
    };

    return (
        <>
            {
                aoi == null &&
                <div className="form-content page-body event-form">
                    <h3>AOIs</h3>
                    <div className='edit-event-form'>
                        <div className='form event-form events-pieline-container'>
                            <div className='form-body'>
                                <div className="events-pieline-list">
                                    {
                                        aois.map((aoi) => {
                                            return <Link to={`/manageevents/${aoi.aoiId}`} key={aoi.aoiId}>{aoi.name}</Link>;
                                        })
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
            {
                aoiId != null &&
                <AoiEvents aoi={aoi} eventId={eventId}/>
            }
            {
                1 == 2 && aoiId != null && editEvent != null &&
                <EditEvent event={editEvent} cancel={cancelEdit} onSave={onSave} forCreate={false} />
            }
            {
                1 == 2 && aoiId != null &&
                <EditEvent event={editEvent} aoi={selectedAoi} cancel={cancelEdit} onSave={onSave} forCreate={true} />
            }
            {
                1 == 2 && aoiId != null &&
                <EventDelete setShowModal={setShowDelete} event={editEvent} cancel={cancelEdit} onDelete={onSave}></EventDelete>
            }
        </>
    );
}

export default ManageEvents;